
<template>
    <div>
        <hr>
        <h2 class="text-center text-uppercase">
            <em class="text-danger">{{ batch.title }}</em>
            Assessment Batch Payments
        </h2>
        <div class="card shadow">

            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th width="15%">Title</th>
                        <th width="10%">Assessment Type</th>
                        <th width="10%">Amount</th>
                        <th width="10%">Date Created</th>
                        <th width="10%">&nbsp;</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ index+1 }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.title }}
                            <strong v-if="row.assessment_type">
                                ({{ row.assessment_type.title }})
                            </strong>
                        </td>
                        <td>
                            {{ row.assessment_type ? row.assessment_type.title : 'N/A' }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.amount | formatPrice }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.created_at | formatDate }}
                        </td>
                        <td>
                            <button
                                class="btn btn-sm btn-info"
                                v-if="! showBreakdown"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="$emit('editBatchPayment', row)"
                            >
                                <i class="fa fa-pen"></i>
                                Edit
                            </button>

                            <button
                                class="btn btn-sm btn-primary"
                                v-if="showBreakdown"
                                :disabled="(privileges && privileges.view == 'no') || ! privileges"
                                @click="$emit('viewBreakdowns', row)"
                            >
                                <i class="fa fa-eye"></i>
                                View Breakdowns
                            </button>

                            <button
                                class="btn btn-sm btn-danger"
                                v-if="! showBreakdown"
                                :disabled="(privileges && privileges.delete == 'no') || ! privileges"
                                @click="deletePayment(row.id)"
                            >
                                <i class="fa fa-ban"></i>
                                Remove
                            </button>
                        </td>
                    </template>
                </base-table>
            </div>

        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'BatchPaymentsData',
        props: ['records', 'privileges', 'batch', 'loadAssessmentPayments', 'showBreakdown'],
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            },
            formatPrice(value) {
                if(value) {
                    let val = (value/1).toFixed(2).replace(',', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ ' NGN';
                } else {
                    return 'N/A';
                }
            }
        },
        methods: {
            ...mapActions(['deleteBatchPayment']),
            deletePayment(id) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        this.makeRemoveApiCall(id);// make api call
                    }
                });
            },
            makeRemoveApiCall(id) {
                this.preloader(); // show loading
                this.deleteBatchPayment(id).then((res) => {// delete country
                    if(res.status) {
                        this.loadAssessmentPayments();// refresh page
                        swal.fire("Payment Deleted", res.msg, "success");
                    } else {
                        this.loadAssessmentPayments();// refresh page
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(err => {
                    this.loadAssessmentPayments();// refresh page
                    swal.fire(err.message+"!", "An error occurred while deleting, try again", "warning");
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
